'use strict'

domConfig = undefined

module.exports =
  get: ->
    if @updatedFinchSettings
      @updatedFinchSettings = false
    else if domConfig
      return domConfig
    domConfig = Groupon.Utils?.getConfigFromDom()
